import { useSequence } from '../motion/useSequence';
import type { SiteDictionary } from '../content/site-content';

const EVIDENCE = ['e1', 'e2', 'e3'] as const;

/**
 * CANTERA, shown instead of described.
 *
 * One company goes through the machine: what was found on its public site, the verdict with the
 * reason attached, and the draft that stops and waits for a person. The last beat is the point,
 * so it is the one the scene rests on.
 */
export function CanteraDemo({ dictionary, paused }: { dictionary: SiteDictionary; paused: boolean }) {
  const t = (key: string) => dictionary[key] ?? key;
  const step = useSequence(6, 1400, paused);

  return (
    <figure className="demo demo--dossier">
      <p className="visually-hidden">{t('cantera.transcript')}</p>

      <figcaption className="demo__head" aria-hidden="true">
        <span className="demo__source">{t('cantera.target')}</span>
        <span className="demo__tag">{t('demo.example')}</span>
      </figcaption>

      <div className="dossier" aria-hidden="true">
        <p className="dossier__label" data-on={step >= 1 || undefined}>{t('cantera.found')}</p>
        <ul className="dossier__evidence">
          {EVIDENCE.map((key, index) => (
            <li data-on={step >= index + 1 || undefined} key={key}>{t(`cantera.${key}`)}</li>
          ))}
        </ul>

        <p className="dossier__verdict" data-on={step >= 4 || undefined}>
          <strong>{t('cantera.verdict')}</strong>
          <span>{t('cantera.reason')}</span>
        </p>

        <p className="dossier__draft" data-on={step >= 5 || undefined}>
          <span className="dossier__draft-label">{t('cantera.draftLabel')}</span>
          {t('cantera.draft')}
        </p>

        <p className="dossier__gate" data-on={step >= 6 || undefined}>{t('cantera.gate')}</p>
      </div>
    </figure>
  );
}
